import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import React from "react";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { createDesignation } from "../../../api/admin/Designation";
import useMounted from "../../../hooks/useMounted";

const CreateNewDesignationModal = (props) => {
  const {
    designationModalState,
    handleCreateNewDesignationModalClose,
    getDesignations,
  } = props;

  const mounted = useMounted();

  return (
    <>
      <Dialog
        open={designationModalState}
        onClose={handleCreateNewDesignationModalClose}
      >
        <Formik
          initialValues={{
            name: "",
            short_name: "",
            description: "",
            submit: null,
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string()
              .max(255)
              .required("Designation Name is required"),
            short_name: Yup.string()
              .max(255)
              .required("Short Name is required"),
            description: Yup.string().max(255).nullable(),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              const res = await createDesignation(values);
              if (res?.data) {
                toast.success("Designation created successfully");
                handleCreateNewDesignationModalClose();
                getDesignations();
              }
              if (mounted.current) {
                setStatus({ success: true });
                setSubmitting(false);
              }
            } catch (err) {
              console.error(err);
              toast.error("Something went wrong");
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form
              noValidate
              onSubmit={handleSubmit}
              autocomplete="off"
              {...props}
            >
              <DialogTitle>Create New Designation</DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Designation Name *"
                      error={Boolean(touched.name && errors.name)}
                      fullWidth
                      helperText={touched.name && errors.name}
                      margin="normal"
                      name="name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.name}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Short Name *"
                      error={Boolean(touched.short_name && errors.short_name)}
                      fullWidth
                      helperText={touched.short_name && errors.short_name}
                      margin="normal"
                      name="short_name"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.short_name}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Description"
                      error={Boolean(touched.description && errors.description)}
                      fullWidth
                      helperText={touched.description && errors.description}
                      margin="normal"
                      name="description"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.description}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                </Grid>

                {errors.submit && (
                  <Box sx={{ mt: 3 }}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Box sx={{ display: "flex", mr: "auto", px: 2, pb: 1 }}>
                  <Box>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Save
                    </Button>
                  </Box>
                  <Box sx={{ ml: 1 }}>
                    <Button
                      disabled={isSubmitting}
                      size="large"
                      variant="contained"
                      onClick={handleCreateNewDesignationModalClose}
                      sx={{ backgroundColor: "#C0CBDE" }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default CreateNewDesignationModal;
